import { render, staticRenderFns } from "./LoadingStruct.vue?vue&type=template&id=b8ed8856&scoped=true"
import script from "./LoadingStruct.vue?vue&type=script&lang=js"
export * from "./LoadingStruct.vue?vue&type=script&lang=js"
import style0 from "./LoadingStruct.vue?vue&type=style&index=0&id=b8ed8856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ed8856",
  null
  
)

export default component.exports